import React, { useState, useEffect } from "react";
import BodySmallMedium from "../designSystem/BodySmallMedium";
import chevron_rightIcon from "../../assets/images/chevron_rightIcon.svg";
import "./Planner.css"
import Heading6Regular from "../designSystem/Heading6Regular";
import CustomCalendar from "./Calendar.jsx";
import ViewDrawer from "./ViewDrawer";
import AddDrawer from "./AddDrawer";
import CopyModal from "./CopyPlanModal";
import CreateTaskModal from "./CreateTaskModal";
import ClearPlanModal from "./ClearPlanModal";
import { useSelector } from "react-redux";
import LoadingOverlay from "../loadingOverlay/LoadingOverlay.jsx";
import PastePlanDrawer from "../Copy Planner/PastePlanDrawer.jsx";
import PasteConfirmationModal from "../Copy Planner/PasteConfirmationModal.jsx";
import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { addEmployeePlan, getEmployeePlan } from "../../actions/userActions/EmployeePlanAction.js";
import { getPlannerSettings } from "../../actions/userActions/employeeAction.js";
const Planner = () => {
    const DRAFT = 1;
    const NEEDSREVISION = 4;
    const dispatch = useDispatch();
    const location = useLocation();
    const notifState = location.state?.fromNotification ? location.state : null;
    const [isViewDrawerOpen, setIsViewDrawerOpen] = useState(false);
    const [isAddDrawerOpen, setIsAddDrawerOpen] = useState(false);
    const [isCopyModalVisible, setIsCopyModalVisisble] = useState(false);
    const [isCreateTaskModalVisible, setIsCreateTaskModalVisisble] = useState(false);
    const [isClearPlanModalVisible, setIsClearPlanModalVisisble] = useState(false);
    const [selectedDay, setSelectedDay] = useState(null);

    // Initialise currentDate from notification deep-link if present
    const [currentDate, setCurrentDate] = useState(() => {
        if (notifState?.month && notifState?.year) {
            return new Date(notifState.year, notifState.month - 1, 1);
        }
        return new Date();
    });

    // When a second notification is clicked while already on this page,
    // location.key changes so we update the calendar month/year accordingly.
    useEffect(() => {
        if (location.state?.fromNotification && location.state?.month && location.state?.year) {
            setCurrentDate(new Date(location.state.year, location.state.month - 1, 1));
        }
    }, [location.key]);
    const pasteMonth = currentDate.getMonth() + 1;
    const pasteYear = currentDate.getFullYear();

    const [eventsForSelectedDay, setEventsForSelectedDay] = useState(null);
    const [isPasteDrawerOpen, setIsPasteDrawerOpen] = useState(false);
    const [isPasteModalOpen, setIsPasteModalOpen] = useState(false);
    const user = JSON.parse(localStorage.getItem("user"));
    const userId = user?.result[0]?.user?.id;
    const [permissions, setPermissions] = useState([]);
    const isLoading = useSelector((state) => state.employeePlan_reducer.isEmployeePlanLoading);
     const { plannerSettings } = useSelector((state) => state.employees_reducer);
      useEffect(() => {
        dispatch(getPlannerSettings());
    }, [dispatch]);

useEffect(() => {
  const storedPermissions = JSON.parse(localStorage.getItem('permissionsList') || '[]');
  setPermissions(storedPermissions);
}, []);


    const onViewDrawerClose = () => {
        setIsViewDrawerOpen(false);
    };
    const onAddDrawerClose = () => {
        setIsAddDrawerOpen(false);
    };
    const onCopyModalClose = () => {
        setIsCopyModalVisisble(false);
    };
    const onCreateTaskModalClose = () => {
        setIsCreateTaskModalVisisble(false);
    };
    const onClearPlanModalClose = () => {
        setIsClearPlanModalVisisble(false);
    };

    const handlePasteClick = () => {
  // setIsPasteDrawerOpen(false); 
    setIsPasteDrawerOpen(true); 

};

const isPlannerOpen = (day) => {
  const today = new Date();
  const clickedDate = new Date(day.year, day.month - 1, day.day);
  const hasUnrestricted = permissions?.includes("AllowUnrestrictedPlannerAccess");
  const hasAddPlan = permissions?.includes("CanAddPlan");
  if (!hasAddPlan) {
    return false;
  }
  const currentYear = today.getFullYear();
  const currentMonth = today.getMonth(); 
  const currentDay = today.getDate();
  const clickedYear = clickedDate.getFullYear();
  const clickedMonth = clickedDate.getMonth();
  if (
    clickedYear === 2026 && 
    clickedMonth === 0 && 
    currentYear === 2026 && 
    currentMonth === 0 && 
    currentDay <= 10
  ) {
    return true; 
  }
  const isNextMonth =
    (clickedYear === currentYear && clickedMonth === currentMonth + 1) ||
    (currentMonth === 11 && clickedYear === currentYear + 1 && clickedMonth === 0);
  if (!isNextMonth) {
    return false;
  }
  if (hasUnrestricted) {
    return true;
  }
  const todayDate = today.getDate();
  if (!plannerSettings || plannerSettings === "isLoading") {
    return false;
  }
  const { startDate, endDate } = plannerSettings;
  if (!startDate || !endDate) {
    return false;
  }
  const isInRange = todayDate >= startDate && todayDate <= endDate;
  return isInRange;
};


const handleDayClick = (day, events, planStatus, myPlan) => {
  setSelectedDay(day);
  setEventsForSelectedDay(events);
  const today = new Date();
  const clickedDate = new Date(day.year, day.month - 1, day.day);
  const isPastDate = clickedDate < new Date(today.getFullYear(), today.getMonth(), today.getDate());

  const isCityOnlyUser = permissions.includes('CanAddPlannerCity') && !permissions.includes('CanAddPlannerTime');

  const isCityOnlyPlan = (evts) => {
    if (!evts || !Array.isArray(evts) || evts.length === 0) return false;
    return evts.every(event => {
      if (!event.planDetails || event.planDetails.length === 0) {
        return (event.cityId || event.headOffice) && !event.startTime;
      }
      return event.planDetails.every(detail => (detail.cityId || detail.headOffice) && !detail.startTime);
    });
  };

  // City-only users can open ViewDrawer for subordinate's normal plans, but not their own
  // No one can open ViewDrawer for city-only plans
  const blockViewDrawer = isCityOnlyPlan(events) || (isCityOnlyUser && myPlan);

  if (permissions.includes("CanViewPlan") && !blockViewDrawer) {
    if (isPastDate) {
      setIsViewDrawerOpen(true); 
      return;
    }
    if (planStatus !== DRAFT && planStatus !== NEEDSREVISION && events !== undefined) {
      setIsViewDrawerOpen(true);
      return;
    }
  }
  if (
    permissions.includes("CanAddPlan") &&
    isPlannerOpen(day) &&
    (planStatus === DRAFT || planStatus === NEEDSREVISION) &&
    !isPastDate
  ) {
    setIsAddDrawerOpen(true);
    return;
  }
};


    const handlePasteModalOpen = () => {
  setIsPasteModalOpen(true);
};

const handlePasteModalClose = () => {
  setIsPasteModalOpen(false);
};

const handleFinalPaste = async () => {
  const copiedData = JSON.parse(localStorage.getItem("copiedPlanData") || "[]");
  const targetDatesSelected = JSON.parse(localStorage.getItem("targetPlanDates") || "{}");

  if (copiedData.length === 0 || Object.keys(targetDatesSelected).length === 0) {
    console.log("Missing copied data or target dates");
    return;
  }

  try {
    for (let i = 0; i < copiedData.length; i++) {
      const copiedPlan = copiedData[i];
      const targetDateRaw = targetDatesSelected[i];

      if (!targetDateRaw) continue;

      const targetDate = new Date(targetDateRaw);
      const yyyy = targetDate.getFullYear();
      const mm = String(targetDate.getMonth() + 1).padStart(2, "0");
      const dd = String(targetDate.getDate()).padStart(2, "0");
      const formattedDate = `${yyyy}-${mm}-${dd}`;

      const filteredPlanDetails = copiedPlan.planDetails;

      if (!filteredPlanDetails || filteredPlanDetails.length === 0) {
        console.log(`Skipping paste: Empty or invalid planDetails at index ${i}`, copiedPlan);
        continue;
      }

      const visitProfileId = copiedPlan?.planDetails?.[0]?.visitProfileId ?? null;

      const payload = {
        employeePlanId: 0,
        employeeId: userId,
        month: targetDate.getMonth() + 1,
        year: targetDate.getFullYear(),
        employeePlanDate: {
          employeePlanDateId: 0,
          planDate: `${yyyy}-${mm}-${dd}`,
          visitProfileId: visitProfileId,
          onLeave: false,
          leaveMessage: "",
          planDetails: filteredPlanDetails.map(detail => ({
            id: 0,
            cityId: detail.cityId,
            startTime: detail.startTime,
            endTime: detail.endTime,
            practiceLocationId: detail.practiceLocationId,
            doctorId: detail.doctorId,
            headOffice: detail.headOffice
          }))
        }
      };

      console.log("Dispatching Paste Plan", copiedData);

      const result = await dispatch(addEmployeePlan(payload));
      console.log("Paste Result for date:", formattedDate, JSON.stringify(result, null, 2));
    }

    localStorage.removeItem("copiedPlanData");
    localStorage.removeItem("targetPlanDates");
  
    setIsPasteModalOpen(false);
    setIsPasteDrawerOpen(false);
    dispatch(getEmployeePlan(userId, pasteMonth, pasteYear));
  } catch (error) {
    console.error("Paste failed with error:", error);
    toast.error("Something went wrong while pasting the plan.");
  }
};

    return (
        <>
        <LoadingOverlay isVisible={isLoading} />
        <div className="planner-container">
              <div className="">
                <CustomCalendar isPlannerOpen = {isPlannerOpen}
                 onDayClick={handleDayClick} onPasteClick={handlePasteClick} currentDate={currentDate}
                setCurrentDate={setCurrentDate}
                notifEmployeeId={notifState?.viewSubordinate ? notifState.employeeId : null}
                />
            </div>
            <ViewDrawer isOpen={isViewDrawerOpen} day={selectedDay} events={eventsForSelectedDay} onClose={onViewDrawerClose} />
            <AddDrawer isOpen={isAddDrawerOpen} day={selectedDay} events={eventsForSelectedDay} onClose={onAddDrawerClose} />
            {isPasteDrawerOpen && (
                <PastePlanDrawer isOpen={isPasteDrawerOpen} onClose={() => setIsPasteDrawerOpen(false)} pasteMonth={pasteMonth} pasteYear={pasteYear} onPasteClick={handlePasteModalOpen}/>
            )}
            <CopyModal isVisible={isCopyModalVisible} onClose={onCopyModalClose} />
            <CreateTaskModal isVisible={isCreateTaskModalVisible} onClose={onCreateTaskModalClose} />
            <ClearPlanModal isVisible={isClearPlanModalVisible} onClose={onClearPlanModalClose} />
            <PasteConfirmationModal 
             isVisible={isPasteModalOpen}
             onClose={handlePasteModalClose}
             onConfirm={handleFinalPaste}
            />
        </div>
        </>
    )
}

export default Planner;